import LogoPL from "@/assets/imgs/logo.png";
import LogoPLBlack from "@/assets/imgs/esesjalogo-big.png"
import LogoDE from "@/assets/imgs/logo-esitzung.png";
import LogoDEBlack from "@/assets/imgs/esitzung_black.png";

const hostname = window.location.hostname;

let appConfig = {};
if (hostname.includes("app-esesja.local") || hostname.includes("app.esesja.pl")) {
    appConfig = {
        meta: {
            title: "eSesja"
        },
        logo: {
            path: LogoPL,
            pathBlack: LogoPLBlack,
            alt: "eSesja"
        },
        language: {
            code: "pl",
            culture: "pl-PL"
        },
        uiConfig: { 
            showNews: true,
        },
        helpPage: {
            url: "https://pomoc.mwc.pl/esesjaadmin/"
        }
    }
}
else if (hostname.includes("app-esitzung.local") || hostname.includes("admin.esitzung.de")) {
    appConfig = {
        meta: {
            title: "eSitzung"
        },
        logo: {
            path: LogoDE,
            pathBlack: LogoDEBlack,
            alt: "eSitzung"
        },
        language: {
            code: "de",
            culture: "de-DE"
        },
        uiConfig: {
            showNews: false,
        },
        helpPage: {
            url: "https://hilfe.esitzung.de/"
        }
    }
}
else {
    appConfig = {
        meta: {
            title: "eSesja"
        },
        logo: {
            path: LogoPL,
            pathBlack: LogoPLBlack,
            alt: "eSesja"
        },
        language: {
            code: "pl",
            culture: "pl-PL"
        },
        uiConfig: {
            showNews: true,
        },
        helpPage: {
            url: "https://pomoc.mwc.pl/esesjaadmin/"
        }
    }
}

export default appConfig;